<template>
  <div class="v-date-range">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      offset-y
      v-bind="menuProps"
      content-class="menu-range-date"
      :location="'top'"
    >
      <!-- <template v-slot:activator="{ on }">
        <v-text-field
          slot="activator"
          class="v-date-range__input-field"
          :value="inputValue"
          readonly
          dense
          :disabled="disabled"
          :placeholder="placeholder"
          v-bind="inputProps"
          v-on="on"
        ></v-text-field>

      </template> -->
      <template v-slot:activator="{ on }">
        <v-btn class="btn-filtro-range-date" v-bind="btnProps" color="primary" v-on="on" slot="activator" v-if="inputValue.length">{{ inputValue.split(' ')[0] }} &mdash; {{ inputValue.split(' ')[2] }}</v-btn>
        <v-btn class="btn-filtro-range-date" v-bind="btnProps" color="primary" outlined v-on="on" slot="activator" v-else>{{ labelBtn }}</v-btn>
        <v-btn class="ml-3" v-if="button" v-bind="btnProps" color="primary" @click="applyRange"> Buscar </v-btn>
      </template> 
      <v-card class="v-date-range__menu-content">
        <v-card-text class="pb-0">
          <v-card-title
            v-if="itemsTypesFilters.length"
            class="pb-0"
          >
            <v-select
              :items="itemsTypesFilters"
              label="Selecione o tipo de filtro"
              dense
              v-model="selectFilter"
              :error-messages="typeFilterErrors"
            />
          </v-card-title>
        </v-card-text>

        <v-card-text class="pa-0">
          <div
            :data-days="highlightDates.length"
            :class="{
              'v-date-range__pickers': true,
              'v-date-range--highlighted': highlightDates.length
            }"
          >
            <v-card-title v-if="$slots.title">
              <slot name="title" v-if="$slots.title"></slot>
            </v-card-title>
            <v-card-text>
              <div class="v-date-range__content">
                <!-- <v-list v-if="!noPresets" class="mr-4">
                  <v-subheader>{{ presetLabel }}</v-subheader>
                  <v-list-tile
                    v-for="(preset, index) in presets"
                    v-model="isPresetActive[index]"
                    :key="index"
                    @click="selectPreset(index)"
                  >
                    <v-list-tile-content>
                      {{ preset.label }}
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list> -->

                <v-list v-if="!noPresets" class="mr-4" dense>
                  <v-subheader>{{ presetLabel }}</v-subheader>
                  <v-list-item-group
                    color="primary"
                  >
                    <v-list-item
                      v-for="(preset, index) in presets"
                      v-model="isPresetActive[index]"
                      :key="index"
                      @click="selectPreset(index)"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ preset.label }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
                <v-date-picker
                  class="mr-4 v-date-range__picker--start v-date-range__picker"
                  v-model="pickerStart"
                  :locale="locale"
                  :first-day-of-week="firstDayOfWeek"
                  :min="min"
                  :max="pickerEnd || max"
                  :no-title="true"
                  :next-icon="nextIcon"
                  :prev-icon="prevIcon"
                  :events="highlightDates"
                  :event-color="highlightClasses"
                ></v-date-picker>
                <v-date-picker
                  class="v-date-range__picker--end v-date-range__picker"
                  v-model="pickerEnd"
                  :locale="locale"
                  :first-day-of-week="firstDayOfWeek"
                  :min="pickerStart || min"
                  :max="max"
                  :no-title="true"
                  :next-icon="nextIcon"
                  :prev-icon="prevIcon"
                  :events="highlightDates"
                  :event-color="highlightClasses"
                ></v-date-picker>
              </div>
            </v-card-text>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="reset" v-if="disableBtnClear">{{ mergedActionLabels.reset }}</v-btn>
          <v-btn text @click="menu = false">{{
            mergedActionLabels.cancel
          }}</v-btn>
          <v-btn
            @click="applyRange"
            color="primary"
            :disabled="!bothSelected"
            >{{ mergedActionLabels.apply }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import { format, parse, differenceInCalendarDays, addDays } from 'date-fns';
import moment from 'moment'
import { validationMixin } from 'vuelidate'
import { requiredIf } from 'vuelidate/lib/validators'
import {
  ISO_FORMAT,
  DEFAULT_ACTION_LABELS
} from './utils/constants';
export default {
  name: 'v-daterange',
  mixins: [validationMixin],
  props: {
    button: {
      type: Boolean,
      default: false
    },
    // Take start and end as the input. Passable via v-model.
    value: {
      type: Object,
      default: () => {
        return { start: '', end: '' };
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    presets: {
      type: Array,
      default: () => {
        return [
          {
            label: 'Hoje',
            range: [
              moment().format('YYYY-MM-DD'),
              moment().format('YYYY-MM-DD'),
            ],
          },
          {
            label: 'Ontem',
            range: [
              moment().add(-1, 'd').format('YYYY-MM-DD'),
              moment().add(-1, 'd').format('YYYY-MM-DD'),
            ],
          },
          {
            label: 'Últimos 7 dias',
            range: [
              moment().add(-7, 'd').format('YYYY-MM-DD'),
              moment().add(-1, 'd').format('YYYY-MM-DD'),
            ],
          },
          {
            label: 'Últimos 30 dias',
            range: [
              moment().add(-30, 'd').format('YYYY-MM-DD'),
              moment().add(-1, 'd').format('YYYY-MM-DD'),
            ],
          },
          {
            label: 'Último mês',
            range: [
              moment().add(-1, 'months').startOf('month').format('YYYY-MM-DD'),
              moment().add(-1, 'months').endOf('month').format('YYYY-MM-DD'),
            ],
          },
        ]
      }
    },
    noPresets: {
      type: Boolean,
      default: false
    },
    // Denotes the Placeholder string for start date.
    startLabel: {
      type: String,
      default: 'Start Date'
    },
    // Denotes the Placeholder string for start date.
    endLabel: {
      type: String,
      default: 'End Date'
    },
    // The string that gets placed between `startLabel` and `endLabel`
    separatorLabel: {
      type: String,
      default: 'To'
    },
    presetLabel: {
      type: String,
      default: 'Presets'
    },
    actionLabels: {
      type: Object,
      default: () => {
        return DEFAULT_ACTION_LABELS;
      }
    },
    /**
     * Following values are all passable to vuetify's own datepicker
     * component.
     */
    // Min selectable date.
    min: {
      type: String,
      default: undefined
    },
    // Max selectable date
    max: {
      type: String,
      default: undefined
    },
    // Locale
    locale: {
      type: String,
      default: 'pt-br'
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    noTitle: {
      type: Boolean,
      default: false
    },
    displayFormat: {
      type: String,
      default: 'DD/MM/YYYY'
    },
    highlightColor: {
      type: String,
      default: 'date-range-in-range'
    },
    showReset: {
      type: Boolean,
      default: true
    },
    /**
     * Icons
     */
    nextIcon: {
      type: String,
      default: '$vuetify.icons.next'
    },
    prevIcon: {
      type: String,
      default: '$vuetify.icons.prev'
    },
    inputProps: {
      type: Object,
      default: () => {
        return {};
      }
    },
    btnProps: {
      type: Object,
      default: () => {
        return {};
      }
    },
    menuProps: {
      type: Object,
      default: () => {
        return {};
      }
    },
    itemsTypesFilters: {
      type: Array,
      default: () => {
        return [];
      }
    },
    labelBtn: {
      type: String,
      default: 'Filtrar por data'
    },
    disableBtnClear: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      menu: false,
      pickerStart: this.value.start,
      pickerEnd: this.value.end,
      highlightDates: [],
      highlightClasses: {},
      selectFilter: '',
    };
  },
  computed: {
    inputValue() {
      if (this.isValueEmpty) {
        return '';
      }
      const start = this.displayFormat
        ? this.formatDate(this.value.start, this.displayFormat)
        : this.value.start;
      const end = this.displayFormat
        ? this.formatDate(this.value.end, this.displayFormat)
        : this.value.end;
      return `${start} ${this.separatorLabel} ${end}`;
    },
    placeholder() {
      return `${this.startLabel} ${this.separatorLabel} ${this.endLabel}`;
    },
    /**
     * If the value prop doesn't have any start value,
     * its most likely that an empty object was passed.
     */
    isValueEmpty() {
      return !this.value.start;
    },
    /**
     * If the user has selected both the dates or not
     */
    bothSelected() {
      return this.pickerStart && this.pickerEnd;
    },
    isPresetActive() {
      return this.presets.map(
        preset =>
          preset.range[0] === this.pickerStart &&
          preset.range[1] === this.pickerEnd
      );
    },
    mergedActionLabels() {
      return { ...DEFAULT_ACTION_LABELS, ...this.actionLabels };
    },

    typeFilterErrors () {
      const errors = []
      if (!this.$v.selectFilter.$dirty) return errors
      !this.$v.selectFilter.required && errors.push('A seleção do filtro é obrigatório')
      return errors
    },
  },
  methods: {
    /**
     * Emit the input event with the updated range data.
     * This makes v-model work.
     */
    applyRange() {
       if (this.$v.selectFilter.$invalid) { 
        this.$v.selectFilter.$touch()
        return false 
      }
      
      this.menu = false;
      this.emitRange();
    },
    /**
     * Called every time the menu is closed.
     * It also emits an event to tell the parent
     * that the menu has closed.
     *
     * Upon closing the datepicker values are set
     * to the current selected value.
     */
    closeMenu() {
      // Reset the changed values for datepicker models.
      this.pickerStart = this.value.start;
      this.pickerEnd = this.value.end;
      this.highlight();
      this.$emit('menu-closed');
    },
    formatDate(date, fmt) {
      // return format(parse(date, ISO_FORMAT, new Date()), fmt);
      return moment(date).format(fmt)
    },
    highlight() {
      if (!this.bothSelected) {
        return;
      }
      const dates = [];
      const classes = {};
      const start = parse(this.pickerStart, ISO_FORMAT, new Date());
      const end = parse(this.pickerEnd, ISO_FORMAT, new Date());
      const diff = Math.abs(differenceInCalendarDays(start, end));

      // Loop though all the days in range.
      for (let i = 0; i <= diff; i++) {
        const date = format(addDays(start, i), ISO_FORMAT);
        dates.push(date);
        const classesArr = [];
        classesArr.push(`v-date-range__in-range`);
        classesArr.push(this.highlightColor);
        i === 0 && classesArr.push(`v-date-range__range-start`);
        i === diff && classesArr.push(`v-date-range__range-end`);
        classes[date] = classesArr.join(' ');
      }
      this.highlightDates = dates;
      this.highlightClasses = classes;
    },
    selectPreset(presetIndex) {
      this.pickerStart = this.presets[presetIndex].range[0];
      this.pickerEnd = this.presets[presetIndex].range[1];
    },
    reset() {
      // Reset Picker Values
      this.pickerStart = '';
      this.pickerEnd = '';
      this.highlightDates = [];
      this.highlightClasses = {};
      this.menu = false;
      this.emitRange();
    },
    emitRange() {
      this.$emit('input', {
        start: this.pickerStart,
        end: this.pickerEnd,
        selectFilter: this.selectFilter ? this.selectFilter : 'created'
      });
    }
  },
  watch: {
    // Watching to see if the menu is closed.
    menu(isOpen) {
      if (!isOpen) {
        this.closeMenu();
      } else {
        this.highlight();
      }
    },
    pickerStart: 'highlight',
    pickerEnd: 'highlight'
  },

  validations () {
    return  {
      selectFilter: {
        required: requiredIf(function () {
          return this.itemsTypesFilters.length ? !!1 : !!0
        })
      },
    }
  }
};
</script>

<style scoped lang="scss">
/* ── Activator button ── */
.btn-filtro-range-date {
  width: 100%;
  height: 38px !important;
}

/* ── Content flex layout (presets | calendars side-by-side) ── */
.v-date-range__content {
  display: flex;
  align-items: flex-start;

  @media (max-width: 960px) {
    flex-direction: column;
    overflow-x: auto;
    overflow-y: scroll;
    max-height: 100vw;
  }
}

/* Range event bubbles — stretch to fill the full cell */
.v-date-range__pickers::v-deep .v-date-picker-table__events {
  height: 100%;
  width: 100%;
  top: 0;
  z-index: -1;
}

.v-date-range__pickers::v-deep .v-picker__body {
  max-width: 100%;
}

/* Square day buttons */
.v-date-range__content::v-deep .v-date-picker-table {
  .v-btn { border-radius: 0; }
}

.v-date-range__pickers::v-deep .v-date-picker-table table {
  width: auto;
  margin: auto;
  border-collapse: collapse;

  th, td { height: 32px; width: 32px; }

  td .v-btn {
    &.v-btn--outline { border: none; box-shadow: 0 0 0 1px currentColor inset; }
    &.v-btn--active::before { background-color: transparent !important; }
  }
}

/* Range highlight */
.v-date-range__pickers::v-deep .v-date-range__in-range {
  height: 100%;
  width: 100%;
  margin: 0;
  border-radius: 0;
}
</style>

<style lang="scss">
$dark-bg:   #1D1D29;
$dark-card: #252535;
$text:      #FFFFFF;
$muted:     #7C7C8A;

/* Scoped to the menu portal by its content-class */
.menu-range-date {
  /* Card wrapper */
  > .v-card {
    background: $dark-bg !important;
    border-radius: 12px !important;
  }

  /* Presets list */
  .v-list { background: $dark-bg !important; }

  .v-subheader {
    color: $muted !important;
    font-size: 11px;
    letter-spacing: 0.6px;
    text-transform: uppercase;
  }

  .v-list-item__title { color: $text !important; font-size: 14px; }
  .v-list-item--active .v-list-item__title { color: var(--v-primary-base) !important; }
  .v-list-item:hover .v-list-item__title { color: var(--v-primary-base) !important; }

  /* v-date-picker dark theme */
  .v-picker {
    background: $dark-card !important;
    border-radius: 12px !important;
    box-shadow: none !important;

    .v-picker__body { background: $dark-card !important; }

    .v-date-picker-header {
      .v-date-picker-header__value button { color: $text !important; font-weight: 600; }
      .v-btn .v-icon { color: $muted !important; }
      .v-btn:hover .v-icon { color: var(--v-primary-base) !important; }
    }

    .v-date-picker-table thead th { color: $muted !important; font-size: 11px; }

    .v-date-picker-table .v-btn {
      color: $text !important;

      &.v-btn--disabled { color: $muted !important; opacity: 0.35; }

      &.v-date-picker-table__current {
        border-color: var(--v-primary-base) !important;
        color: var(--v-primary-base) !important;
        font-weight: 700;
      }

      &.v-btn--active {
        background-color: var(--v-primary-base) !important;
        color: #FFF !important;
        &::before { background-color: transparent !important; }
      }
    }
  }

  /* Action buttons */
  .v-card__actions {
    background: $dark-bg !important;
    border-top: 1px solid rgba(255,255,255,0.06);

    .v-btn--text { color: $muted !important; }
    .v-btn--text:hover { color: $text !important; }
  }

  /* Range highlight bubble → full-cell green tint */
  .date-range-in-range {
    background: rgba(var(--v-primary-base), 0.18) !important;
    border-radius: 0 !important;
    height: 100%;
    width: 100%;
    margin: 0;
  }
}
</style>